import { IScaffoldActionSelectionChanged, ScaffoldState } from "./interface";

/**
 * Handles the SELECTION_CHANGED action by syncing an externally controlled selection
 * value into the reducer state and clearing the selection anchor.
 * The anchor is cleared because the parent has overridden the selection, making any
 * previously recorded anchor stale.
 *
 * @param action - The SELECTION_CHANGED action carrying the new selection value from props.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the new selection and a cleared anchor.
 */
export const scr_selectionChanged = <T>(
  action: IScaffoldActionSelectionChanged,
  state: ScaffoldState<T>,
): ScaffoldState<T> => ({
  ...state,
  selection: action.selection,
  selectionAnchor: null,
});
